

/// <reference path="DBMappingEntity.ts" />

// Generated class DBMappingEntityCashDesk_ManagedObject

class DBMappingEntityCashDesk_ManagedObject extends DBMappingEntity
{
}
